export default {
  newest: 'newest',
  oldest: 'oldest',
};
